
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import { Box, Chip } from '@mui/material';
import FilterTable from '../../../../atoms/TableComponent/FilterTable/FilterTable';
import axiosInstance from '../../../../lib/axios';
import moment from 'moment';
import AttendenceCalender from './AttendenceCalender';
import { getRoomMasterdropdata } from '../../../../Api/PropertyMst/Api';

 function Attandancetable() {
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const permissions = usePermissions("MP Attendance");
    const { AddRec = "0" } = permissions || {};
    const [calendarOpen, setCalendarOpen] = useState(false);
     const [dropdownData, setDropdownData] = useState([]);
  const userId = sessionStorage.getItem('UserId');
  console.log("UserId from sessionStorage:", permissions);
      useEffect(() => {
          const fetchDropdownData = async () => {
              try {
                  const response = await getRoomMasterdropdata({
                      Flag: "",
                      UserId: userId,
                  });
                  if (response?.data?.Status === 0) {
                      const dropdownItems = response.data.Data.map((item) => ({
                          id: item.PropId,
                          name: item.Name,
                      }));
                      setDropdownData(dropdownItems);
                    //   if (dropdownItems.length > 0) {
                    //       setSelectedProperty(dropdownItems[0]);
                    //       setFormData(prev => ({ ...prev, Property: dropdownItems[0].id }));
                    //   }
                  }
              } catch (error) {
                //   toast.error("Error fetching property data");
              }
          };
  
          fetchDropdownData();
      }, [userId]);
    useEffect(() => {
        fetchData();
    }, []);
  const handleCalendarClose = (filters) => {
        setCalendarOpen(false);
    };
    const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post(
                'TrnMpAttn/GetTrnMpAttnDashBoard',
                {
                    start: 1,
                    PageSize: 1,
                    SearchText: ""
                }
            );

            if (response.data.Status === 0) {
                const formattedData = response.data.Data.map(workStn => ({
                    ...workStn,
                    PropName:workStn.PropName,
                    ShiftName:workStn.ShiftName,
                    AttnWorker:workStn.AttnWorker,
                    PlanWorker:workStn.PlanWorker,
                    AttnDt:workStn.AttnDt? moment(workStn.AttnDt).format('DD-MM-YYYY') : '',
                    HkWrkStnName: workStn.HkWrkStnName || '',
                    Abrv: workStn.Abrv || '',
                    Remark: workStn.Remark || '',
                    Status: workStn.Status === null ? '' : (workStn.Status == 1 ? 'Active' : 'Inactive'),
                }));
                setRows(formattedData);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error('Error while fetching data:', error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handlePermittedClick = () => {
        if (AddRec === "1") {
            handleClick();
        }
    };

    const handleClick = () => {
        navigate('/operations/attendance', { state: { mode: "add" } });
    };
      const handleCalendarClick = () => {
        setCalendarOpen(true)
  };

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleLocationclick = () => {
        navigate('/operations/housekeepin');
    };

    // const handleRowDoubleClick = (params) => {
    //    const hkWrkStnId = params?.data?.HkWrkStnId;
    //     // if (hkWrkStnId) {
    //         navigate('/operations/attendance', { state: { HkWrkStnId: hkWrkStnId, mode: 'view' } });
    //     // }
    // }; 

    const handleRowDoubleClick = (params) => {
    const rowData = params?.data;
    console.log("Row data on double click:", rowData);
    if (rowData) {
        navigate('/operations/attendance', { 
            state: { 
                mode: 'view',
                propertyId: rowData.PropId,
                propertyName: rowData.PropName,
                attendanceDate: rowData.AttnDt,
                shiftId: rowData.ShiftId,
                shiftName: rowData.ShiftName
            } 
        });
    }
};

    const TruncatedCellRenderer = (props) => {
        const [isOverflowed, setIsOverflowed] = useState(false);
        const cellRef = React.useRef(null);

        useEffect(() => {
            if (cellRef.current) {
                const isTextOverflowed =
                    cellRef.current.scrollWidth > cellRef.current.clientWidth ||
                    (props.value && props.value.length > 20);
                setIsOverflowed(isTextOverflowed);
            }
        }, [props.value]);

        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

        return (
            <div
                ref={cellRef}
                className="truncated-cell"
                style={{ width: '100%' }}
            >
                {cellValue}
            </div>
        );
    };

    const StatusCellRenderer = (props) => {
        const getStatusColor = (status) => {
            switch (status) {
                case 'Active':
                    return '#4caf50';
                case 'Inactive':
                    return '#f44336';
                default:
                    return '#f44336';
            }
        };

        return (
            <Chip
                label={props.value}
                className="status-chip"
                sx={{
                    backgroundColor: getStatusColor(props.value),
                    color: 'white',
                    width: '100%',
                    maxWidth: '100px',
                }}
            />
        );
    };

    const columnDefs = [
        { headerName: 'Sr.No.', field: 'RowNum', width: 60, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
         { headerName: 'Attendence Date', field: 'AttnDt', minWidth: 100, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Property.', field: 'PropName', width: 200, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Shift', field: 'ShiftName', minWidth: 100, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Attendence Worker', field: 'AttnWorker', minWidth: 100, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        { headerName: 'Plan Worker', field: 'PlanWorker', minWidth: 100, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
       
        { headerName: 'Remark', field: 'Remark', minWidth: 100, flex: 1, filter: 'agTextColumnFilter', cellRenderer: TruncatedCellRenderer },
        // { headerName: 'Status', field: 'Status', width: 100, filter: 'agTextColumnFilter', cellRenderer: StatusCellRenderer },
    ];

    return (
        <Box sx={{ height: '90vh' }}>
            <FilterTable
                columnDefs={columnDefs}
                rowData={rows}
                onRowDoubleClicked={handleRowDoubleClick}
                isLoading={isLoading}
                onHomeClick={handleHomeClick}
                onParentClick={handleLocationclick}
                breadcrumbParentLabel="Operations"
                breadcrumbCurrentLabel="Attendance"
                onAddClick={handlePermittedClick}
                hasAddPermission={AddRec === "1"}
                 showCalendarButton={true}
               onCalendarClick={handleCalendarClick}
               calendarButtonTooltip="View Attendance Calendar"
               hasCalendarPermission={true}
            />
            <AttendenceCalender
                open={calendarOpen}
                onClose={handleCalendarClose}
                dropdownData={dropdownData}
                userId={userId}
            />
        </Box>
    );
}


export default Attandancetable
